import { atom } from '~/observers/jotai'

import { ListStudentsDTO } from './types'
import { defaultListValue } from './variables'

export const studentsAtom = atom<ListStudentsDTO>(defaultListValue)
